import { createApp } from 'vue'
import { createVuetify } from 'vuetify'

const app = createApp({})

app.use(createVuetify)

export default createVuetify()
